import {
  inject,
  Injectable,
  Injector,
  runInInjectionContext,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { isNil, isNotNil } from '@web/utils';
import { RequiredMethodCallException } from '../../exceptions/required-method-call.exception';
import { HTTP_ERROR_HANDLERS } from '../tokens/http-error-handlers';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorService {
  private readonly handlers = inject(HTTP_ERROR_HANDLERS);

  private _response!: HttpErrorResponse;

  private readonly injector = inject(Injector);

  public extract(response: HttpErrorResponse): this {
    this._response = response;

    return this;
  }

  public messages(): string[] {
    this.requireExtract();

    for (const handler of this.handlers) {
      const messages = runInInjectionContext(this.injector, () =>
        handler(this._response),
      );

      if (isNotNil(messages)) {
        return messages;
      }
    }

    return [];
  }

  public multiLineMessages(): string {
    return this.messages().join('\n');
  }

  private requireExtract(): void {
    if (isNil(this._response)) {
      throw new RequiredMethodCallException(this.extract.name);
    }
  }
}
